<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            DESPESAS GERAIS - <b-badge variant="warning">BUSCA</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
                        <b-row>
                            <b-col sm="12" md="4">
                                <b-form-group>
                                    <label class="required" for="movimento">Id do movimento no RM</label>
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            id="movimento"
                                            placeholder="Digite o id do movimento"
                                            v-model="movimentoId"
                                            v-mask="['#########']"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button
                                                variant="primary"
                                                @click="pesquisarMovimentoCompra()"
                                                title="Clique para pesquisar o movimento"
                                            >
                                                <i class="fa fa-search"></i>
                                            </b-button>
                                        </b-input-group-append>
                                        <b-form-invalid-feedback>
                                            O id do movimento é obrigatório
                                        </b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>

                        </b-row>
                        <div v-if="movimento">
                            <b-row>
                                <b-col sm="12" md="6">
                                    <b-form-group>
                                        <label>Razão social</label>
                                        <b-input-group>
                                            <b-form-input
                                                type="text"

                                                v-model="fornecedor"
                                                :disabled="true"
                                            ></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" md="2">
                                    <b-form-group>
                                        <label>Valor do movimento</label>
                                        <b-input-group>
                                            <money
                                                v-model="movimento.valor"
                                                v-bind="money"
                                                class="form-control text-right"
                                                :disabled="true"
                                            ></money>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="12" md="2">
                                    <b-form-group>
                                        <label> Data de emissão </label>
                                        <date-picker
                                            v-model="dataEmissao"
                                            :config="$datePickerOptions"
                                            v-mask="'##/##/####'"
                                            :disabled="true"
                                        ></date-picker>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" md="2">
                                    <b-form-group>
                                        <label> Data de movimento </label>
                                        <date-picker
                                            v-model="dataMovimento"
                                            :config="$datePickerOptions"
                                            v-mask="'##/##/####'"
                                            :disabled="true"
                                        ></date-picker>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" md="2">
                                    <b-form-group>
                                        <label> Data de vencimento </label>
                                        <date-picker
                                            v-model="dataVencimento"
                                            :config="$datePickerOptions"
                                            v-mask="'##/##/####'"
                                            :disabled="true"
                                        ></date-picker>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" md="2">
                                    <b-form-group>
                                        <label>Valor Total do movimento</label>
                                        <b-input-group>
                                            <money
                                                v-model="movimento.valorTotal"
                                                v-bind="money"
                                                class="form-control text-right"
                                                :disabled="true"
                                            ></money>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="12">
                                    <b-form-group>
                                        <label> Histórico </label>
                                        <b-form-textarea
                                            v-model="movimento.historico"
                                            :rows="3"
                                            :disabled="true"
                                        ></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card-body>
                    <b-card-footer>
                        <slot name="botoes"></slot>
                        <div class="float-right">
                            <b-button
                                variant="success"
                                @click.stop="confirmarSalvar()"
                                :disabled="!habilitarSalvar"
                            >
                                <span> <i class="fa fa-check"></i> Inserir </span>
                            </b-button>
                        </div>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        erros: {
            type: Array,
            default: () => ([])
        },

        movimento: {
            type: Object,
            default: () => null
        }
    },

    data() {
        return {
            movimentoId: null,
            xl: 4,
            lg: 4,
            md: 4,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    methods: {
        pesquisarMovimentoCompra() {
            if (this.movimentoId == null) {
                return null
            }

            this.$emit('pesquisarMovimentoCompra', this.movimentoId)
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Despesa',
                html: `Confirma a inserção do movimento <b>${this.movimento.idMov}</b> como despesa geral?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$emit('inserir', this.movimento)
        }
    },

    created() {},

    watch: {

    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        },

        fornecedor() {
            if (this.movimento == null) {
                return null
            }

            return this.movimento.cpfCnpj + " - " + this.movimento.nomeFornecedor
        },

        dataEmissao() {
            if (this.movimento == null || this.movimento.dataEmissao == null) {
                return null
            }

            return this.$moment(this.movimento.dataEmissao).format('DD/MM/YYYY')
        },

        dataMovimento() {
            if (this.movimento == null || this.movimento.dataMovimento == null) {
                return null
            }

            return this.$moment(this.movimento.dataMovimento).format('DD/MM/YYYY')
        },

        dataVencimento() {
            if (this.movimento == null || this.movimento.dataVencimento == null) {
                return null
            }

            return this.$moment(this.movimento.dataVencimento).format('DD/MM/YYYY')
        },

    },

    validations: {
        movimento: {
            movimntoOK() {
                return this.movimento != null
            }
        }
    },
}
</script>
